import { createContext } from 'react';

export const NonprofitOnboardingDataCaptureFlowContext = createContext<
  | null
  | (Record<string, unknown> & {
      send: (event: unknown) => void;
      isTransitionAllowed: (event: string) => boolean;
    })
>(null);
